var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayinline = function SvgPlayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 7.134C14.1667 7.51888 14.1667 8.48112 13.5 8.86602L1.5 15.7942C0.833332 16.1791 0 15.698 0 14.9282L0 1.0718C0 0.301953 0.833333 -0.179133 1.5 0.205792L13.5 7.134Z"
  })));
};
export default SvgPlayinline;